/* eslint-disable default-param-last */
import { Paper } from "@mui/material";
import { Loader, ratios } from "@platformx/utilities";
import { formThumbnailFromGCBURL } from "@platformx/x-image-render";
import { memo } from "react";

const ArticleImageRender = (props: any = {}) => {
  const {
    content = {}, //image from dspace/GCB
    imgOrder = {
      1440: "hero",
      1280: "hero",
      1024: "portrait",
      768: "portrait",
      600: "square",
      320: "square",
    }, //breakpoints with ratios
    isCropLoading = false,
  } = props;
  const { Thumbnail } = content || {};
  // Build CDN thumbnail URL from the GCB relative path.
  // Falls back to the raw dspace Thumbnail when no GCB path is available.
  const thumbnailUrl = content?.original_image_relative_path
    ? formThumbnailFromGCBURL(
        content?.original_image_relative_path,
        content?.ext,
        "quality=85,format=webp",
      )
    : Thumbnail || "";

  return (
    <>
      {isCropLoading && <Loader />}
      {thumbnailUrl ? (
        <Paper
          sx={{
            aspectRatio: {
              xs: ratios[imgOrder["320"]],
              sm: ratios[imgOrder["600"]],
              md: ratios[imgOrder["768"]],
              em: ratios[imgOrder["1024"]],
              lg: ratios[imgOrder["1280"]],
              xl: ratios[imgOrder["1440"]],
            },
            height: "inherit",
          }}>
          <img
            src={thumbnailUrl}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            alt='img'
          />
        </Paper>
      ) : null}
    </>
  );
};

export default memo(ArticleImageRender);
